import { render, staticRenderFns } from "./LargeImg.vue?vue&type=template&id=25b4f5fc&scoped=true&"
import script from "./LargeImg.vue?vue&type=script&lang=js&"
export * from "./LargeImg.vue?vue&type=script&lang=js&"
import style0 from "./LargeImg.vue?vue&type=style&index=0&id=25b4f5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b4f5fc",
  null
  
)

export default component.exports